import React, { useEffect } from "react";
import Header from "./components/0. Header/Header";
import Loading from "./components/0. Utilidades/loadingGIF";

const Layout = ({ children }) => {
  useEffect(() => {
    // Preload the loading component
    Loading();
  }, []);
  return (
    <>
      <Header />
      <div id="Body">{children}</div>
    </>
  );
};

export default Layout;
